import { render, staticRenderFns } from "./bo-announcement-bar.vue?vue&type=template&id=04641180"
import script from "./bo-announcement-bar.vue?vue&type=script&lang=js"
export * from "./bo-announcement-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/staging-adhoc.boostorder.net/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04641180', component.options)
    } else {
      api.reload('04641180', component.options)
    }
  }
}
component.options.__file = "resources/js/bo-components/v2/components/bo-announcement-bar.vue"
export default component.exports